import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, UserRecord } from '@tassat/fred-definitions';
import { browserSessionStore } from '@tassat/utility';

const initialState = null as UserRecord | null;

const userRecordAction = createAction<UserRecord>(CoreMsgTypes.UserRecord);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userRecordAction, (_state, action) => {
                if (import.meta.env.NPM_CONFIG_MOCK || browserSessionStore.getItem('userid') === action.payload.UserId) {
                    return action.payload;
                }
            });
    }
});

export default userSlice.reducer;